// external
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

// store
import { GET_CURRENT_MXR_RETAILER } from '@/store/types';

// models
import MxrRetailer from '@/interfaces/MxrRetailer';

@Component({
})
export default class RetailerLocation extends Vue {
    @Prop({ required: true }) location!: MxrRetailer;

    @Prop({ required: true }) selected!: boolean;

    @Getter(GET_CURRENT_MXR_RETAILER) getCurrentMxrRetailer!: MxrRetailer;

    get name() {
        const retailerName = this.location.Chain ? this.location.Chain : this.location.Partner;
        if (retailerName.toLowerCase() === 'qfc') {
            return this.location.Chain.toUpperCase();
        }
        const headerWords = retailerName.split(' ');
        for (let i = 0; i < headerWords.length; i++) {
            headerWords[i] = headerWords[i][0].toUpperCase() + headerWords[i].substr(1);
        }
        return `${headerWords.join(' ')}`;
    }

    get distance() {
        return this.location.FormattedDistance;
    }

    get address() {
        return {
            street: this.location.Street,
            city: this.location.City,
            state: this.location.State,
            zip: this.location.ZipCode.slice(0, 5),
        };
    }

    onSelected(e: Event) {
        const isSelected = this.selected;
        let isLocation = this.location;
        if (isSelected) {
            isLocation = this.getCurrentMxrRetailer;
        }
        this.$emit('locationSelected', isLocation);
    }
}
